<template>
  <!-- 當日分時車流推估人流 -->
  <div>
    <div class="d-flex justify-content-end">
      <button  class="btn btn-dia " style="" @click="showModal()" v-if="!isShortView">
        <i class="fas fa-search-plus"></i>
      </button>
    </div>
    <div id="chart" style=" margin-bottom:20px">
      <apexchart
        v-if="chartSeries"
        type="area"
        :options="chartOptions"
        :series="chartSeries"
      ></apexchart>
    </div>

    <dialog-modal  id="allScenicAreaPeopleFlowPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
      :isImage="false" :isMarginAuto="false" :modalTitle="'當日分時推估人流'" :closeButton="false" >
      <div class="object-detection-detail w-75 m-auto" >
          <apexchart
            v-if="chartSeries"
            type="area"
            id="chartPop"
            :options="chartOptions"
            :series="chartSeries"
          ></apexchart>
      </div>
    </dialog-modal>
    
   
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "./DialogModal.vue";
import CONST from "../utils/const";
import Utils from "../utils/utils";
import { mapState, mapGetters } from "vuex";
import { postVehicleInTimeIntervalPerHour } from "../api/eastCoastDataApi/ElkQuery/VehicleElk";
import axios from "axios";
const zh_tw = require("../utils/apexchartObject/apexLocales/zh-tw.json");
export default {
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  data() {
    return {
      dataInterval: null,
      chart: null,
      chartData: [],
      chartSeries: [],
      viewPort: window.innerWidth,
      isShortView:false,
      chartOptions: {
        chart: {
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
          },
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend:{
          fontSize: "12px", 
          labels: {
            colors: undefined
          },
          onItemClick: {
            toggleDataSeries: false
          }
          
        },
        fill:{
          type: "gradient",
          opacity:0.2,
          gradient:{
            shade: 'dark',
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 0.6,
          stops: [0,0],
          }
        },
        stroke: {
          curve: 'smooth',
          width: 1,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            // format:'HH',
            datetimeFormatter: {
              day: "MM/dd",
              hour: "HH",
            },
          },
          tooltip:{
            enabled:false,
          },
          categories: [],
        },
        tooltip: {
          x: {
            // format: "MM/dd  HH",
            formatter:undefined,
            
          },
          y: {
            formatter:undefined,
            // formatter: function (val) {
            //   return val + "人";
            // },
            title:{
              formatter:function(){
                return "";
              }
            }
          },
        },
        colors: CONST.APEXCHART_COLOR.SCENIC_AREA,
        markers: {
          size: 0, // 圓點的大小
          //colors: ["#FF0000"], // 圓點的顏色
          //strokeColors: "#fff", // 圓點的邊框顏色
          strokeWidth: 1, // 圓點邊框的寬度
          hover: {
            size: 2, // 滑鼠懸停時圓點的大小
          },
        },
      },
    };
  },

  computed: {
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    
    removeNegativeAndDecimal(value) {
     //若 value < 0 則回傳 0，若value > 0 則回傳四捨五入後的整數
      return value < 0 ? 0 : Math.round(value)
    },

    drawChart: function () {
      let vm = this;
      let areaShowArray = this.chartData
        .map((item) => {
          return item.areaName;
        })
        .filter((item, index, self) => {
          return self.indexOf(item) === index;
        });
      // console.log("this.chartData",this.chartData);

      let seriesData = areaShowArray.map((currentArea, indexArea) => {
        //取得每個area的數據
        let result = {};
        result.name = currentArea;
        let areaData = vm.chartData
          .filter((item) => item.areaName == currentArea)
          .map((item) => this.removeNegativeAndDecimal(item.totalPeopleFlow));

        // 因未經歷過的時間的並不會回傳人流資料，故則需限制data為24
        //如果 areaData 長度不足 24，使用 0 填補剩餘的部分 
        if (areaData.length < 24) {
          areaData = areaData.concat(Array(24 - areaData.length).fill(0));
        }

        result.data = areaData;
        return result;
      });
      // console.log("seriesData", seriesData);

      let totalData = {};
      totalData.name = "總計";
      totalData.data = [];
      totalData.color = "transparent";
   
      //將每個 area 的人流加總 (總共有 24 個值，分別代表 0~23 時的人流數量)
      for(let i=0 ;i <seriesData[0].data.length;i++){
        let sum = 0;
        for(let j=0;j<seriesData.length;j++){
          sum += seriesData[j].data[i];
        }
        //將sum加入totalData;
        // totalData.data.push(sum);
        // console.log("sum",sum);
      }

      // seriesData.push(totalData);
      // console.log("seriesData",seriesData);
      // console.log("totalData",totalData);

      
      let newOptions = { ...this.chartOptions };
      // newOptions.xaxis.categories = this.chartData.map(
      //   (current) => current.dateTime
      // );

      const startDate = moment().startOf("day"); // 獲取當天的開始時間，即午夜 00:00
      const dataLength = 24;
      const categories = [];

      for (let i = 0; i < dataLength; i++) {
        const hour = moment(startDate).add(i, "hours").format("HH:mm");
        const date = moment(startDate).format("YYYY-MM-DD");
        const category = `${date} ${hour}`;
        categories.push(category);
      }
      
      newOptions.xaxis.categories = categories;
      this.chartOptions.tooltip.x.formatter = function  (val,{ series, seriesIndex, dataPointIndex,w }) {
        if(series === undefined){
          return
        }

        let result = null;
        
        for(let i=0;i<series.length;i++){
            result += series[i][dataPointIndex] ;
        }
        return `${moment(val).format("MM/DD HH")} - ${moment(val).add(1, 'hours').format("HH")} <br><br>
                <span style="">總計【${vm.formatNumber(result)}】人</span> `;
      };
      this.chartOptions.tooltip.y.formatter = function (val,{ series, seriesIndex, dataPointIndex,w }) {
        // console.log("seriesIndex",seriesIndex)
        // console.log("dataPointIndex",dataPointIndex)
        // console.log("w",vm.myScenicAreaList)
        //顯示各景區同時段的人流數量
        let result = "";
        let total = 0;
      //   for(let i=0;i<series.length;i++){
      //     result += `${ seriesData[i].data[dataPointIndex]} 人<br>`;
      //     // result += `${this.myScenicAreaList[i].name}  人<br>`;
      //  }
      // return result;
      // for(let i=0;i<seriesData.length;i++){
      //   total += seriesData[i].data[dataPointIndex];
  
      // }
      // result += `<span style="font-weight:800;">總計【${vm.formatNumber(total)}】人</span>`;
        // return result;
        // return result;
        for(let i=0;i<seriesData.length;i++){
          total += seriesData[i].data[dataPointIndex];
          result+= ` <span style="font-weight:400;">${seriesData[i].name} 【${ seriesData[i].data[dataPointIndex]}】 人</span><br>`;
        }
      // return result;
        for(let i=0;i<seriesData.length;i++){
          total += seriesData[i].data[dataPointIndex];
          result+= ` <span style="font-weight:400;">${seriesData[i].name} 【${ seriesData[i].data[dataPointIndex]}】 人</span><br>`;
        }
      
      //顯示各景區該時段人流數量+ 總計數量
      // return  val + " 人";
      return `${seriesData[seriesIndex].name} - ${seriesData[seriesIndex].data[dataPointIndex]} 人 <br> `;

      };

      // this.chartOptions.tooltip.y.custom = function(val,{ series, seriesIndex, dataPointIndex,w }){

      // }

       
      newOptions.chart.toolbar.export = {
        csv: {
          filename: `當日分時車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
        },
        svg: {
          filename: `當日分時車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
        },
        png: {
          filename: `當日分時車流推估人流_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
        },
      };

      //將總計的顏色改為透明
      //若series 為 8 組，則前7個顏色為黑色，最後一個為透明
      // const scArray =  seriesData.length;
      // let colorArray = [];
      // for(let i=0;i<scArray-1;i++){
      //   colorArray.push("#000");
      // }
      // // console.log("color",colorArray)
      // colorArray.push ("transparent");
      // // if()
      // this.chartOptions.legend.labels.colors = colorArray;

      
      this.chartOptions = newOptions;
      this.chartSeries = seriesData;

      // this.chartSeries = [
      //   {
      //     name: seriesData.name,
      //     data: seriesData.data,
      //   },
      // ];
   
    },
    searchPeopleFlow: async function () {
      // let startTime= moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
      // let endTime =  moment().format("YYYY-MM-DD HH:mm:ss");
      let condition = {
        //areas: null,
        areas: this.myScenicAreaList.map((s) => s.id),
        // sttime: moment('2023-04-02').subtract(24, 'hours'),
        // endtime: moment('2023-04-05'),

        // sttime: moment('2023-11-04').subtract(24, 'hours'),
        // endtime: moment('2023-11-01').endOf('day'),
        
        // sttime: moment("2023-04-03").startOf("day"),
        // endtime: moment("2023-04-03").endOf("day").subtract(10, "hour"), //測試用切割時間

        sttime:  moment().startOf("day").format(),
        endtime: moment().startOf("minute").format(), //取得當日最早時間與當下最近小時
        interval: "hour",
      };

      let response = await postVehicleInTimeIntervalPerHour(condition);

      return response.data;
    },

    //判斷每一千份位數字加入逗號  
    formatNumber(num) {
      const str = num.toString();
      const reg = /\B(?=(\d{3})+($|\.))/g;
      return str.replace(reg, ",");

    },

    async GetAndSetChartData() {
      let data = await this.searchPeopleFlow();
      
      // console.log("data", data);
      this.chartData = data;
    },
  },
  watch: {
    chartData(newData, oldData) {
      // 當 chartData 更新時，這裡的代碼會被執行
      if (newData !== oldData) {
        if (!this.myScenicAreaList || this.myScenicAreaList.length == 0) return;
        this.drawChart();
      }
    },
    async myScenicAreaList(newData, oldData) {
      if (newData !== oldData) {
        await this.GetAndSetChartData();
      }
    },

    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },
  },
  async mounted() {
    if (this.myScenicAreaList) await this.GetAndSetChartData();
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);
    this.dataInterval = setInterval(async () => {
      this.GetAndSetChartData();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>
<style lang="scss" scoped>
#chart {
  max-width: 450px;
  margin: 0 auto;
}

#chartAllScenicAreaPeopleFlow {
  max-width: 490px;
  margin: 0 auto;
}

</style>
